export const colors = {
	brand_colors_primary: {
		royol_blue_deep: '#2B25B8',
		royol_blue: '#3F66FA',
		royol_blue_shiny: '#8DA5FF',
		royol_blue_pastel: '#EBEFFF',
		blue_sky_deep: '#00B6F6',
		blue_sky: '#4AC8F5',
		blue_sky_shiny: '#A6E8FF',
		blue_sky_pastel: '#E7F9FF',
		noir_blue_deep: '#1C1359',
		noir_blue: '#2F2380',
		noir_blue_shiny: '#7565E3',
		noir_blue_pastel: '#E2DEFF',
	},
	brand_colors_contemplary: {
		violet_deep: '#541B92',
		violet: '#6A2CAD',
		violet_shiny: '#CDABF1',
		violet_pastel: '#F6EDFF',
		mint_green_deep: '#00C3C5',
		mint_green: '#37DDDE',
		mint_green_shiny: '#9DFEFF',
		mint_green_pastel: '#CFFFFF',
	},
	neutral_colors: {
		midnight_sky: '#1C1D38',
		royal_blue: '#48495D',
		stone_gray: '#9192AD',
		silver_gray: '#E6E7F7',
		ice_gray: '#F7F7FF',
	},
	system_colors: {
		success_pure: '#37C6AB',
		success_light: '#5FE2BE',
		success_medium: '#14B8A6',
		success_dark: '#048A89',
		helper_pure: '#FFBE62',
		helper_light: '#FFD181',
		helper_medium: '#FFA02E',
		helper_dark: '#DB7E21',
		warning_pure: '#FA4549',
		warning_light: '#FF8182',
		warning_medium: '#CF222E',
		warning_dark: '#A40E26',
	}
}

export const Spacings = {
	inset: {
		'3XS': '4px',
		'2XS': '8px',
		'1XS': '12px',
		'XS': '16px',
		'SM': '24px',
		'MD': '32px',
		'LG': '40px',
	},
	squish: {
		'3XS': '4px 8px',
		'2XS': '8px 16px',
		'XS': '16px 24px',
		'SM': '16px 32px',
		'MD': '16px 40px',
	},
	inline: {
		'none': '0',
		'5XS': '4px',
		'4XS': '8px',
		'3XS': '16px',
		'2XS': '24px',
		'XS': '32px',
		'SM': '40px',
		'MD': '48px',
		'LG': '64px',
		'XL': 'px',
	},
	stack: {
		'none': '0px',
		'5XS': '4px',
		'4XS': '8px',
		'3XS': '16px',
		'2XS': '24px',
		'XS': '32px',
		'SM': '40px',
		'MD': '48px',
		'LG': '56px',
		'XL': '64px',
		'2XL': '80px',
	}

}